import { SimplePageContentWrapper, SimplePageLayout, SimplePageHeader } from '@flexinet/ui-components';
import { ReportsRecordsTable } from '../../invoices/tables/ReportsRecordsTable';
import { ReportPageNavigation } from '../navigation/ReportPageNavigation';

export const InvoicesReportPage = () => {
  return (
    <SimplePageLayout
      pageHeader={<SimplePageHeader title="Invoices Report" />}
      pageNavigation={<ReportPageNavigation reportName="Invoices Report" />}
    >
      <SimplePageContentWrapper>
        <ReportsRecordsTable />
      </SimplePageContentWrapper>
    </SimplePageLayout>
  );
};